export default class FileWithExpiry {
    file: File;
    isExpiryTracked = false;
    expiresAt = '';
}